import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const timeoutRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    // Check if we're on the home page
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to home page first
      navigate('/');
      // Scroll to section after navigation
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
    setIsMenuOpen(false);
  };

  const toggleServices = () => {
    if (isMobile) {
      setIsServicesOpen(!isServicesOpen);
    }
  };

  const handleServicesMouseEnter = () => {
    if (!isMobile) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setIsServicesOpen(true);
    }
  };

  const handleServicesMouseLeave = () => {
    if (!isMobile) {
      timeoutRef.current = setTimeout(() => {
        setIsServicesOpen(false);
      }, 200);
    }
  };

  const handleDropdownMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsServicesOpen(true);
  };

  const handleDropdownMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsServicesOpen(false);
    }, 200);
  };

  const handleServiceClick = (path) => {
    navigate(path);
    setIsServicesOpen(false);
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <img 
            src={location.pathname.startsWith('/mentora') ? '/Mentora_Logo.jpg' : '/logo-black-HR-Consol.png'} 
            alt={location.pathname.startsWith('/mentora') ? 'Mentora' : 'Hrconsol'} 
            className="logo-image"
          />
        </div>
            <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <li>
                <button 
                  className="nav-link" 
                  onClick={() => scrollToSection('home')}
                >
                  Home
                </button>
              </li>
              <li 
                className={`nav-item-dropdown ${isServicesOpen ? 'active' : ''}`}
                onMouseEnter={handleServicesMouseEnter}
                onMouseLeave={handleServicesMouseLeave}
              >
                <button className="nav-link" onClick={toggleServices}>
                  Services <i className="fas fa-chevron-down"></i>
                </button>
                {isServicesOpen && (
                  <ul 
                    className="dropdown-menu"
                    onMouseEnter={handleDropdownMouseEnter}
                    onMouseLeave={handleDropdownMouseLeave}
                  >
                    <li onClick={() => handleServiceClick('/executive-search')}>Executive Search</li>
                    <li onClick={() => handleServiceClick('/tech-recruitment')}>Tech Recruitment</li>
                    <li onClick={() => handleServiceClick('/recruitment-process-outsourcing')}>Recruitment Process Outsourcing</li>
                    <li onClick={() => handleServiceClick('/labour-contractor')}>Labour Contractor & Manpower Supplier</li>
                    <li onClick={() => handleServiceClick('/payroll-outsourcing')}>Payroll Outsourcing</li>
                    <li onClick={() => handleServiceClick('/startup-consultancy')}>Startup Consultancy</li>
                    <li onClick={() => handleServiceClick('/od-consultancy')}>OD & Management Consultancy</li>
                    <li onClick={() => handleServiceClick('/performance-management')}>Performance Management</li>
                    <li onClick={() => handleServiceClick('/hr-policy')}>HR Policy Management</li>
                    <li onClick={() => handleServiceClick('/training-solutions')}>Specialized Training Solutions</li>
                  </ul>
                )}
              </li>
              <li>
                <button 
                  className="nav-link" 
                  onClick={() => scrollToSection('about')}
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  className="nav-link nav-link-mentora" 
                  onClick={() => handleServiceClick('/mentora')}
                >
                  Mentora
                </button>
              </li>
              <li>
                <button 
                  className="nav-link" 
                  onClick={() => scrollToSection('contact')}
                >
                  Contact
                </button>
              </li>
            </ul>
        <div 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Header;
